import apiClient from '@api/client';

export interface ConnectWiseLinkConfig {
  site: string;
  company: string;
  loginUrl: string;
}

export function normalizeConnectWiseLinkConfig(
  config: Partial<ConnectWiseLinkConfig> | null | undefined,
): ConnectWiseLinkConfig {
  const site = (config?.site || '').replace(/^https?:\/\//i, '').replace(/\/+$/, '');
  const company = (config?.company || '').trim();
  const loginUrl = (config?.loginUrl || '').trim() || buildLoginUrl(site, company);

  return { site, company, loginUrl };
}

export function connectWiseRecordUrl(
  config: ConnectWiseLinkConfig | null,
  routeTo: string,
  recId: string | number,
): string {
  if (!config?.loginUrl || recId === '' || recId == null) return '#';
  const appredirect = `?locale=en_US&routeTo=${routeTo}&recid=${recId}`;
  return `${config.loginUrl}&appredirect=${encodeURIComponent(appredirect)}`;
}

export function connectWiseTicketUrl(config: ConnectWiseLinkConfig | null, recId: string | number): string {
  return connectWiseRecordUrl(config, 'ServiceFV', recId);
}

export function connectWiseOpportunityUrl(config: ConnectWiseLinkConfig | null, recId: string | number): string {
  return connectWiseRecordUrl(config, 'OpportunityFV', recId);
}

export async function fetchConnectWiseLinkConfig(): Promise<ConnectWiseLinkConfig> {
  const response = await apiClient.get<ConnectWiseLinkConfig>('/api/connectwise/link-config');
  return normalizeConnectWiseLinkConfig(response.data);
}

function buildLoginUrl(site: string, company: string): string {
  if (!site || !company) return '';
  return `https://${site}/?company=${encodeURIComponent(company)}&usehttps=1`;
}
